import util from '@utils/util';
import emailWay from './email';
import phoneWay from './phone';
import selectWay from './select';
import thridWay from './third';
import emailForget from './email/forget';
import phoneForget from './phone/forget';
export default {
  name: 'logreg',
  props: {
    thirdHost: {
      type: String,
      default: ''
    },
    oldThirdHost: {
      type: String,
      default: ''
    },
    clientId: {
      type: String,
      default: ''
    },
    showContent: {
      type: Boolean,
      default: false
    },
    // inHome: { type: Function, default: () => {} },
    // updateUserInfo: { type: Function, default: () => {} },
    close: {
      type: Function,
      default: function _default() {}
    },
    success: {
      type: Function,
      default: function _default() {}
    },
    fail: {
      type: Function,
      default: function _default() {}
    }
  },
  components: {
    'select-way': selectWay,
    'email-way': emailWay,
    'phone-way': phoneWay,
    'third-way': thridWay,
    'email-forget': emailForget,
    'phone-forget': phoneForget
  },
  data: function data() {
    return {
      wayType: 'email',
      isShowLogin: true,
      forgetState: '',
      loginName: '',
      itc: '',
      country: ''
    };
  },
  computed: {},
  methods: {
    showForgetHandle: function showForgetHandle(type, name, itc, country) {
      this.isShowLogin = false;
      this.forgetState = type;
      this.loginName = name;
      this.itc = itc;
      this.country = country;
    },
    selectWayHandle: function selectWayHandle(type) {
      this.isShowLogin = true;
      this.wayType = type;
    },
    back: function back() {
      this.close();
      util.KEWLSensorTrack({
        lmweb_clickText: '关闭登陆'
      });
    }
  },
  watch: {
    showContent: function showContent(val) {
      if (!val) {
        this.wayType = 'email';
        this.isShowLogin = true;
      }
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};